// extracted by mini-css-extract-plugin
export default {"animation-fast-ms":"300","animation-slow-ms":"800","FeedbackButton":"feedback-button_FeedbackButton__3-ErS typography_heading__3JzIA"};